$.fn.countdown = function (options, callback) {
  // var abar = $('.utility-bar').detach();
  // $("sticky-header").prepend(abar);
  // console.log("moved")
  var settings = $.extend({
    date: null,
    offset: null,
    day: 'Day',
    days: 'Days',
    hour: 'Hour',
    hours: 'Hours',
    minute: 'Minute',
    minutes: 'Minutes',
    second: 'Second',
    seconds: 'Seconds'
  }, options);

  if (!settings.date) {
    $.error('Date is not defined.');
  }

  if (!Date.parse(settings.date)) {
    $.error('Incorrect date format, it should look like this, 12/24/2012 12:00:00.');
  }

  var container = this;
  var currentDate = function () {
    var date = new Date();

    var utc = date.getTime() + (date.getTimezoneOffset() * 60000);
    var new_date = new Date(utc + (3600000*settings.offset));
    return new_date;
  };

  function countdown () {
    var target_date = new Date(settings.date),
        current_date = currentDate();

    var difference = target_date - current_date;
    $('.header-countdown-timer').show().addClass('timer-visible');
    if (difference < 0) {
      clearInterval(interval);
      if (callback && typeof callback === 'function') callback();
      return;
    }

    var _second = 1000,
        _minute = _second * 60,
        _hour = _minute * 60,
        _day = _hour * 24;

    var days = Math.floor(difference / _day),
        hours = Math.floor((difference % _day) / _hour),
        minutes = Math.floor((difference % _hour) / _minute),
        seconds = Math.floor((difference % _minute) / _second);

    var text_days = (days === 1) ? settings.day : settings.days,
        text_hours = (hours === 1) ? settings.hour : settings.hours,
        text_minutes = (minutes === 1) ? settings.minute : settings.minutes,
        text_seconds = (seconds === 1) ? settings.second : settings.seconds;

    // console.log(days+"D "+hours+"H "+minutes+"M "+seconds+ "S")
    var TimeText = "";
    if(days > 0){
      TimeText += days+" Days "+ hours+" Hours";
    }else{
      TimeText += hours+" Hours"+minutes+" Minutes";
    }
    // $('.custom-sale-label span').html(TimeText);
    
    days = (String(days).length >= 2) ? days : '0' + days;
    hours = (String(hours).length >= 2) ? hours : '0' + hours;
    minutes = (String(minutes).length >= 2) ? minutes : '0' + minutes;
    seconds = (String(seconds).length >= 2) ? seconds : '0' + seconds;

    container.find('.days1').text(String(days).substring(0,1));
    container.find('.days2').text(String(days).substring(1,2));
    container.find('.hours1').text(String(hours).substring(0,1));
    container.find('.hours2').text(String(hours).substring(1,2));
    container.find('.minutes1').text(String(minutes).substring(0,1));
    container.find('.minutes2').text(String(minutes).substring(1,2));
    container.find('.seconds1').text(String(seconds).substring(0,1));
    container.find('.seconds2').text(String(seconds).substring(1,2));

    container.find('.days_text').text(text_days);
    container.find('.hours_text').text(text_hours);
    container.find('.minutes_text').text(text_minutes);
    container.find('.seconds_text').text(text_seconds);
  }
  var interval = setInterval(countdown, 1000);
};
$('.announcement-bar-timer').countdown({
  date: $('.announcement-bar-timer').data('time'),
  offset: $('.announcement-bar-timer').data('timezone'),
  day: 'Day',
  days: 'Days'
}, function () {
  $('.announcement-bar-timer').remove();
});

function UpdateTop(){
  var Aheight = $('.utility-bar').height();
  var Acss = '<style id="ancss">.shopify-section-header-sticky{ top: '+Aheight+'px; }</style>';
  $('#ancss').remove();
  $('body').append(Acss);
}
UpdateTop();
$(window).resize(function(){
  UpdateTop();
});